import {Col, Form, Row} from 'antd';
import {useFormikContext} from 'formik';
import {Input, Switch} from 'formik-antd';
import {useIntl} from 'react-intl';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import IntlMessages from 'src/domain/utility/IntlMessages';
import FormItem from 'src/shared/components/form-item';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';
import LanguageCode from 'src/shared/services/types/language-code';
import MainUtils from 'src/shared/utils/main';
interface IRejectionReasonsStandardProps {}

const RejectionReasonsStandard = (props: IRejectionReasonsStandardProps) => {
  const {messages} = useIntl();
  const {setFieldValue, values} = useFormikContext<any>();
  const {locale}: any = useLocaleContext();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='name'
            label={messages['common.reason'].toString()}
            fieldCommponent={
              <Input
                name={'name'}
                value={getLocaleValue(
                  values?.locales,
                  !MainUtils.isEmptyValue(locale.code)
                    ? locale.code
                    : LanguageCode.English,
                  'name',
                )}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    !MainUtils.isEmptyValue(locale.code)
                      ? locale.code
                      : LanguageCode.English,
                    'name',
                    value.target.value,
                  )
                }
                className='fullContent'
              />
            }
          />
        </Col>
        <Col span={24}>
          <FormItem
            name='isActive'
            label={messages['common.isActive'].toString()}
            fieldCommponent={
              <Switch
                name='isActive'
                checkedChildren={<IntlMessages id='common.active' />}
                unCheckedChildren={<IntlMessages id='common.inactive' />}
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default RejectionReasonsStandard;
